








































import {Component, Prop, Vue} from 'vue-property-decorator'
import {Game} from "@/models/Game";
import {Round} from "@/models/Round";
import RoundHeader from "@/components/round-information/RoundHeader.vue";
import RoundLogic from "@/components/round-information/RoundLogic.vue";
import {Player} from "@/models/Player";
import ScoreBoard from "@/components/ScoreBoard.vue";
import EndScreen from "@/components/TheEndScreen.vue";
import NewGameDialog from "@/components/round-information/NewGameDialog.vue";

@Component({
    components: {EndScreen, ScoreBoard, RoundLogic, RoundHeader, NewGameDialog}
})
export default class TheGameLoop extends Vue {

    @Prop()
    private readonly game: Game;

    @Prop()
    private readonly reloaded: boolean;

    private mutableGame: Game;

    private guess = true;

    private playerIndex = 0;

    private guessCounter = 0;

    private actualCounter = 1;

    private showScoreBoard = false;

    private showNewGameDialog = false;

    created() {
        this.mutableGame = this.game;
        if (!this.reloaded) {
            this.mutableGame.rounds.push(new Round());
            this.updateGame()
        }
        this.guessCounter = 0;
        this.actualCounter = this.activeRound;
    }

    get activePlayer() {
        return this.game.players[this.playerIndex].name;
    }

    get activeRound() {
        return this.game.rounds.length;
    }

    private increasePlayerIndex() {
        this.playerIndex++;
    }

    private decreasePlayerIndex() {
        if (this.guess) {
            const guesses = this.mutableGame.rounds[this.activeRound-1].getGuesses();
            this.guessCounter = this.guessCounter - guesses[this.playerIndex-1].getValue();
        } else {
            const actuals = this.mutableGame.rounds[this.activeRound-1].getActuals();
            this.actualCounter = this.actualCounter + actuals[this.playerIndex-1].getValue();
        }
        this.playerIndex--;
    }

    private setGuess(chosenValue: number) {
        this.mutableGame.rounds[this.activeRound - 1].setGuess(this.playerIndex, chosenValue);
        this.guessCounter += chosenValue;
    }

    private setActual(chosenValue: number) {
        this.mutableGame.rounds[this.activeRound - 1].setActual(this.playerIndex, chosenValue);
        this.actualCounter -= chosenValue;
    }

    private changeToActuals() {
        this.playerIndex = 0;
        this.guess = false;
    }

    private createNextRound() {
        this.calculateScoresForRound();
        this.showScoreBoard = true;
        this.mutableGame.rounds.push(new Round());
        this.guessCounter = 0;
        this.actualCounter = this.activeRound;
        this.guess = true;
        this.playerIndex = 0;
        this.shiftPlayers();
    }

    private calculateScoresForRound() {
        const guesses = this.mutableGame.rounds[this.activeRound - 1].getGuesses();
        const actuals = this.mutableGame.rounds[this.activeRound - 1].getActuals();

        for (let i = 0; i < guesses.length; i++) {
            let roundScore = 0;
            const guess = guesses[i].getValue();
            const actual = actuals[i].getValue();
            if (guess === actual) {
                roundScore += (20 + (10 * guess));
            } else {
                roundScore -= Math.abs(guess - actual) * (10);
            }
            this.mutableGame.players[i].score += roundScore;
        }
    }

    private shiftPlayers() {
        const players: Player[] = this.mutableGame.players;
        const shiftedPlayers: Player[] = [];
        for (let i = 0; i < players.length - 1; i++) {
            shiftedPlayers.push(players[i + 1]);
        }
        shiftedPlayers.push(players[0]);
        this.mutableGame.players = shiftedPlayers;
    }

    private openScoreBoard() {
        this.showScoreBoard = true;
    }

    private closeScoreBoard() {
        this.showScoreBoard = false;
    }

    private openNewGameDialog() {
        this.showNewGameDialog = true;
    }

    private closeNewGameDialog() {
        this.showNewGameDialog = false;
    }

    private updateGame() {
        this.$emit('update-game', this.mutableGame);
    }

    private newGame() {
        this.$emit('new-game')
    }

    private endGame() {
        this.updateGame()
        this.$emit('show-end-screen');
    }
}
